import React from 'react';
import PropTypes from 'prop-types';


export const NAV_TITLES = {
  CATALOGUE: 'catalogue',
  CART: 'cart',
  DASHBOARD: 'dashboard',
  PROFILE: 'profile',
  REGISTER_ACCOUNT: 'register-account',
  WALLET: 'wallet',
  MY_BOOKINGS: 'my-bookings',
  SANDOS_4U: 'sandos4u',
}

const getTitleText = (titleId, lang, context) => {
  switch (titleId) {
    case NAV_TITLES.CATALOGUE:
      return context.t('Sandos4U');
    case NAV_TITLES.CART:
      return context.t('Shopping Cart');
    case NAV_TITLES.DASHBOARD:
      return context.t('Dashboard');
    case NAV_TITLES.PROFILE:
      return context.t('Your Account');
    case NAV_TITLES.REGISTER_ACCOUNT:
      return context.t('Register Account');
    case NAV_TITLES.WALLET:
      return context.t('Wallet');
    case NAV_TITLES.MY_BOOKINGS:
      return context.t('Bookings');
    case NAV_TITLES.SANDOS_4U:
      return 'Sandos4U';
    default:
      return '';
  }
}

/**
 * We want this component to only re-render when either the titleId or the language change
 * For this, we have used a PureComponent, using selectors or Dumb component didn't seem to work
 */
class NavTitle extends React.PureComponent {
  componentDidUpdate(prevProps) {
    // When the title changes, we update the window title as well
    const hasTitleChanged = prevProps.titleId !== this.props.titleId || prevProps.lang || this.props.lang;
    if (hasTitleChanged) {
      document.title = getTitleText(this.props.titleId, this.props.lang, this.context);
    }
  }

  render() {
    const { titleId, lang } = this.props;

    // refs #110039 the title is disabled in the home page
    if (this.props.history.location.pathname === '/') {
      return null;
    }

    return (
      <div className="m-0 md:hidden text-xl text-center text-white font-semibold">
        {getTitleText(titleId, lang, this.context)}
      </div>
    );
  }
}


NavTitle.propTypes = {
  titleId: PropTypes.string,
  lang: PropTypes.string,
  history: PropTypes.object.isRequired,
}

NavTitle.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default NavTitle;
